(function($){

  let contactUsTabs = document.querySelector('.component--tabs-contact-us');

  if (contactUsTabs) {
    let mobileTrigger = contactUsTabs.querySelectorAll('.mobile-trigger button');

    mobileTrigger.forEach((button)=> {
      button.addEventListener('click', (e)=> {
        $(button).closest('.mobile-trigger').next('.tab-pane').slideToggle();
        $(button).attr('aria-expanded', (i, attr)=> {
          return attr == 'false' ? 'true' : 'false';
        })
      })
    })
  }


})(jQuery);


